<template>
    <div class="choose_box pop-up2">
        
        <div>
            <Row class="con">
                <Col :span="8">
                    <Radio v-model="select" label="0">保存为已有模板：</Radio>
                </Col>
                <Col :span="16">
                    <Select v-model="gid"   placeholder="请选择" :disabled="select == 1" style="width:100%">
                        <Option v-for="(item,i) in tagArr" :key="i" :label="item.name" :value="item.gid"></Option>
                    </Select> 
                </Col>
            </Row>
            <Row class="con">
                <Col :span="8">
                    <Radio v-model="select" label="1">新增为选书模板：</Radio>
                </Col>
                <Col :span="16">
                    <Input  :disabled="select == 0" v-model="name" ></Input>
                </Col>
            </Row>

        </div>


        <div class="btn_box">
            <Button class="btn_add_canle" @click="cancelInventtory">取消</Button>
            <Button class="btn_add_sure" @click="submitSave" >保存</Button>
        </div>
    </div>
</template>
    
    <script>
        import {Row,Col,Button,Checkbox,Radio,Select,Option,Input} from 'element-ui'
        import Axios from "@/api/diyaxios";
        import Cookies from 'js-cookie'

        export default {
            props: ['objdata'],
            components:{
                Row,Col,Button,Checkbox,Radio,Select,Option,Input
            },
            data() {
                return {
                    select:'0',
                    disabled:false,
                    gid:'',
                    name:'',
                    tagArr:[],
                }
            },
            watch:{
            },
            created(){
                
            },
            mounted() {
                let vm = this;
                vm.getList();
                
            },
            methods:{
                getList(){
                    let vm = this,
                        url = "/template/action/search";
                    Axios.post(url, { params: {
                            orgId:Cookies.get('orgGid')
                        }},
                            {
                                headers: {
                                    "Content-Type": "application/json"
                                }
                            }
                        ).then(res => {
                            vm.tagArr = res.data || [];
                        }).catch(err => {
                    });
                },
               
                //提交
                submitSave() {
                    let vm = this;
                    if(vm.select == '1'){//新增模板时
                        if(vm.name && vm.name.length > 0 && vm.name.length <= 40){
                           vm.add();
                        }else{
                            this.$message({
                                message: '模板名称1到40个字符！',
                                type: 'info'
                            })     
                        }
                    }else{
                        vm.add();
                    }
                },
                //取消
                cancelInventtory(){
                    let vm = this;
                    vm.$emit('cancel')
                },
                getName(gid){
                    let name = '';
                    this.tagArr.forEach(element => {
                        if(element.gid == gid){
                            name = element.name;
                        }
                    });
                    return name;
                },
                add() {
                    let vm = this,
                        url = "/template/action/save",
                        saveobj = Object.assign({}, vm.objdata);
                    if(vm.select == '0'){
                        saveobj.gid = vm.gid;
                        saveobj.name = vm.getName(vm.gid);
                    }else{
                        saveobj.name = vm.name;
                    }
                    Axios.post(url, { params: saveobj },
                        {
                            headers: {
                                "Content-Type": "application/json"
                            }
                        }
                    ).then(res => {
                        if(res.status){
                            this.$message({
                                message: "加入模板成功！",
                                type: "success",
                                duration:800
                            });
                            vm.$emit('submit');
                        }else{
                            this.$message({
                                message: res.msg,
                                type: "success",
                                duration:800
                            });
                        }
                    }).catch(err => {
                    });
                
                    // var obj = {
                    //     goodsIdList:vm.objdata.gids,
                    //     userId: Cookies.get('UserID'),
                    //     amount: vm.amount
                    // }
                    // vm.isLoad = true;
                    // vm.beforeAddCar(obj).then(function(obj){
                    //     if(obj.goodsIdList && obj.goodsIdList.length > 0){
                    //         addMoreOrder(obj).then(response => {
                    //             vm.$message({
                    //                 message: '加入购物车成功',
                    //                 type: 'success'
                    //             });
                    //                 vm.$emit('submit');
                    //         })
                    //      }else{
                    //         vm.$emit('cancel')
                    //      }
                    // })
                }
            }
        }
    </script>
    
    <style lang='scss'>
        .choose_box{
           .con{
               padding: 10px 30px;
               line-height: 40px;
           }
        }
    </style>


// WEBPACK FOOTER //
// src/views/getBook/choose.vue